import { render, staticRenderFns } from "./AllSvg.vue?vue&type=template&id=19cbbf87&scoped=true&"
import script from "./AllSvg.vue?vue&type=script&lang=js&"
export * from "./AllSvg.vue?vue&type=script&lang=js&"
import style0 from "./AllSvg.vue?vue&type=style&index=0&id=19cbbf87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cbbf87",
  null
  
)

export default component.exports